import type { TourConfig } from '../types';

export const usersPageTour: TourConfig = {
  pageId: 'users',
  pageName: 'Users & Reps',
  portalId: 'crm',
  steps: [
    {
      element: '[data-tour="invite-user"]',
      title: 'Invite User',
      intro:
        'Send an email invitation to add a new team member. Choose their role (Admin or Rep) during the invite.',
      platform: 'both',
      requiredRoles: ['owner', 'admin'],
    },
    {
      element: '[data-tour="users-table"]',
      title: 'Users Table',
      intro:
        'View all team members with their role, status, and creation date. Click the edit icon to change a user\'s name or role.',
      platform: 'both',
      requiredRoles: ['owner', 'admin'],
    },
    {
      element: '[data-tour="role-legend"]',
      title: 'Role Permissions',
      intro:
        'Reference guide for each role: Owner has full access, Admin manages users and rules, Rep views companies and own projects.',
      platform: 'both',
      requiredRoles: ['owner', 'admin'],
    },
  ],
};
